<div class="spinner-background">
    <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
</div>